import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  handleError(error: any): void {
    console.error(error);
    const chunkFailedMessage = /Loading chunk [\w-~]+ failed/;

    if (chunkFailedMessage.test(error.message) && window && window.confirm && window.confirm('网站已经更新，需要刷新后才能正常访问。点击确定后会自动刷新')) {
      window.location.reload();
    }
  }
}
